import { type TextProps } from 'tamagui';
import { Text } from '@/components/text';

// Section header (h2): `title` role, 24/28 Fraunces 600, tracking -0.01em
// (about -0.2px at 24px). Subordinate to Heading so the page still has one
// first place for the eye.
export function Subheading({ children, ...props }: TextProps) {
  return (
    <Text
      fontFamily="$heading"
      fontWeight="$semibold"
      fontSize="$title"
      lineHeight="$title"
      letterSpacing={-0.2}
      color="$color"
      {...props}
    >
      {children}
    </Text>
  );
}
